const ClubImageFormModal = () => import("@media/components/modals/ClubImageFormModal.vue");
const ClubPreRollFormModal = () => import("@media/components/modals/ClubPreRollFormModal.vue");

export default { ClubImageFormModal, ClubPreRollFormModal };
